import Swal from 'sweetalert2';
import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { AvantoModalControlService } from 'src/app/services/avanto-modalControl.service';
import { AvantoRoutingService } from 'src/app/services/avanto-routing.service';
import { ScrollFunctions } from '../../../util/ScrollFunctions';
import { AvantoSessionService } from 'src/app/services/avanto-session.service';
import { Subscription } from 'rxjs';
import { AvantoUserAuthService } from 'src/app/services/avanto-user-auth.service';
import { AvantoCustomerService } from 'src/app/services/avanto-customer-info.service';
import { AvantoAlert } from 'src/app/util/Alerts';
import { SessionObject } from 'src/app/avantoeats-util/models/session/SessionObject';
import { CartObject } from 'src/app/avantoeats-util/models/cart/CartObject';
import BigNumber from 'bignumber.js';

@Component({
  selector: 'app-checkout-page',
  templateUrl: './checkout-page.component.html',
  styleUrls: ['./checkout-page.component.scss']
})
export class CheckoutPageComponent implements OnInit, OnDestroy, AfterViewInit {
  sessionId: string;

  isUserSignedIn: boolean;

  orderSummaryUnavailableBtnMsg: string;

  customerAddress: string;
  customerAddressNote: string;

  orderType: string;
  orderTime: string;

  customerId: string;
  customerName: string;
  customerPhone: string;

  cartSelectedRestaurant: string;
  cartSelectedRestaurantName: string;
  cartSelectedRestaurantAddress: string;

  cartIsEmpty: boolean;

  subtotal: number;
  tax: number;
  extraFees: { title: string, value: number }[] = [];
  discounts: { title: string, value: number }[] = [];
  total: number;
  showProcessingSpinner: boolean;

  showPayOnlineButton: boolean;
  showPayAtRestaurant: boolean;
  showPayMonerisButton:boolean;
  showPayThirdPartyButton:boolean;
  //Apple Pay / Google Pay buttons (Square). Only for restaurants with a digital wallet turned on
  showGooglePayWallet:boolean;
  showApplePayWallet:boolean;
  isWalletPaymentProcessing:boolean = false;
  showTipsForPickup:boolean;
  showTipsForDelivery:boolean;

  hasPayOnline:boolean;

  monerisPostParams:any;
  thirdPartyPaymentParams:any;
  thirdPartyPaymentType:string;
  payAtRestaurantPickupOptions: string[];
  payAtRestaurantDeliveryOptions: string[];

  isOneRestaurantMode: boolean;
  selectedRestaurantId: string;
  oneRestaurantModePickupOnly: boolean;

  hasCoupon: boolean;
  couponDiscountTxt: string;
  selectedTipBtn: number;
  selectedTipValue: number;

  pickupPreparationTime: string;
  deliveryPreparationTime: string;

  isFutureOrderTimeValidTxt: string;
  isRestaurantAvailableTxt: string;
  isCartValidtxt: string;
  invalidCartItemList:string[]
  isOrderTotalValidTxt: string;
  highlightDateTimeSelectionArea: boolean;
  isSessionValid: boolean;
  wasSessionValidatedAtLeastOnce: boolean;
  validateSessionIsRunningAndWillStopSpinner:boolean;

  sessionSubscription: Subscription = new Subscription();
  orderDetailsChangedSubscription: Subscription = new Subscription();

  didWeCheckIfNoTipsYet: boolean;
  showOrderSummaryDetails:boolean;


  constructor(private avantoModal: AvantoModalControlService, private customerService: AvantoCustomerService, private avantoSession: AvantoSessionService, 
    private avantoRoute: AvantoRoutingService, private auth: AvantoUserAuthService) { }

  ngOnInit() {
    this.showProcessingSpinner = true;

    this.isUserSignedIn = false;

    this.subtotal = 0;
    this.tax = 0;
    this.extraFees = [];
    this.discounts = [];
    this.total = 0;

    this.hasCoupon = false;
    this.didWeCheckIfNoTipsYet = false;
    this.showOrderSummaryDetails = true;
    this.couponDiscountTxt = null;
    this.selectedTipBtn = null;
    this.selectedTipValue = null;

    this.cartIsEmpty = null;

    //===== User authentication initialization =====\\

    //TODO: DONT LOAD IF YOU ALREADY HAVE IT SAVED ON THE SESSION!!!
    //WHAT HAPPENS IF I LOGOUT?!???!?!?!?!
    this.auth.getCustomerInfo()
      .then((customerInfo) => {

        this.isUserSignedIn = true;
        
        //Saves the logged in customer information on the session
        this.avantoSession.setCustomerInfo(customerInfo)
          .then(() => {
            this.showProcessingSpinner = false;
          }).catch((ex) => {
            //If this error happens, the problem is not with the login, but with the session that could not be saved. I show the following message just to save face
            console.error("Could not save customer info on the session!!!", ex)
            this.showProcessingSpinner = false;
            this.isUserSignedIn = false;
            this.orderSummaryUnavailableBtnMsg = "Sign in to Complete the Order"
          })

      }).catch(() => {
        this.orderSummaryUnavailableBtnMsg = "Sign in to Complete the Order"
        this.showProcessingSpinner = false;
      })
    //===== User authentication initialization END =====\\





    this.wasSessionValidatedAtLeastOnce = false;
    this.validateSessionIsRunningAndWillStopSpinner = false;
    this.validateSession()
    .catch((err) => { console.log(err) })
    .finally(() => {



      //===== Session initialization =====\\
      this.sessionSubscription = this.avantoSession.sessionSubject.subscribe((session) => {

        this.sessionId = session.sessionId;

        //--- CART ---\\
        if (session.cart.cartItems.size != 0) {
          this.cartIsEmpty = false;
        } else {
          this.cartIsEmpty = true;
        }
        this.subtotal = session.cart.subtotal
        this.tax = session.cart.tax
        this.extraFees = session.cart.restaurantFees
        this.discounts = session.cart.discounts
        this.total = session.cart.total





        //--- ORDER INFORMATION ---\\
        this.orderType = session.orderType;
        this.orderTime = session.orderDate;
        const isDelivery = session.orderType == SessionObject.ORDER_TYPE_DELIVERY;
        const isPickup = !isDelivery;





        //--- RESTAURANT INFORMATION ---\\
        this.cartSelectedRestaurant = session.restaurantInformation.restaurantId;
        this.cartSelectedRestaurantName = session.restaurantInformation.title;
        this.cartSelectedRestaurantAddress = session.restaurantInformation.address;






        //--- PAYMENT INFORMATION ---\\
        this.showPayOnlineButton = (session.restaurantInformation.paymentOptions.payOnlineForDelivery && isDelivery) || (session.restaurantInformation.paymentOptions.payOnline && isPickup);
        this.hasPayOnline = session.restaurantInformation.paymentOptions.payOnlineForDelivery || session.restaurantInformation.paymentOptions.payOnline;

        this.showPayAtRestaurant = (session.restaurantInformation.paymentOptions.payAtRestaurantForDelivery && isDelivery) || (session.restaurantInformation.paymentOptions.payAtRestaurant && isPickup);
        if (this.showPayAtRestaurant) {
          this.payAtRestaurantDeliveryOptions = session.restaurantInformation.paymentOptions.payAtRestaurantOptionsDelivery;
          this.payAtRestaurantPickupOptions = session.restaurantInformation.paymentOptions.payAtRestaurantOptionsPickup;
        }

        //Moneris
        this.showPayMonerisButton = session.restaurantInformation.paymentOptions.monerisPostParams!=null && (
                                    (session.restaurantInformation.paymentOptions.payMonerisForDelivery && isDelivery) ||
                                    (session.restaurantInformation.paymentOptions.payMoneris && isPickup)
                                  );
        if(this.showPayMonerisButton){
          this.monerisPostParams = session.restaurantInformation.paymentOptions.monerisPostParams;
        }
                      
        //Third Party                                  
        this.thirdPartyPaymentType = session.restaurantInformation.paymentOptions.thirdPartyType;
        this.showPayThirdPartyButton = session.restaurantInformation.paymentOptions.thirdPartyType!=null &&
          session.restaurantInformation.paymentOptions.thirdPartyPostParams!=null && (
            (session.restaurantInformation.paymentOptions.payThirdPartyForDelivery && isDelivery) ||
            (session.restaurantInformation.paymentOptions.payThirdParty && isPickup)
          );
        this.thirdPartyPaymentParams = session.restaurantInformation.paymentOptions.thirdPartyPostParams;

        //Digital wallets are charged through Square, so they're only offered next to a Square pay button
        const digitalWallets = session.restaurantInformation.paymentOptions.digitalWallets;
        const paysWithSquare = this.showPayOnlineButton || (this.showPayThirdPartyButton && this.thirdPartyPaymentType == "square");
        this.showGooglePayWallet = paysWithSquare && digitalWallets != null && (isDelivery ? digitalWallets.googlePayForDelivery : digitalWallets.googlePay);
        this.showApplePayWallet  = paysWithSquare && digitalWallets != null && (isDelivery ? digitalWallets.applePayForDelivery : digitalWallets.applePay);

      
        
        


        //- TIPS, COUPONS AND FEES -\\
        if (this.selectedTipBtn == null) {
          this.extraFees.forEach(fee => {
            //If we've set up a tip for this order
            if (fee.title == CartObject.TIP_FEE_NAME) {
              this.selectedTipBtn = 3; //OTHER fee button
              this.selectedTipValue = fee.value;
            }
          });
        }

        this.hasCoupon = session.cart.usedCouponCode != undefined;
        this.showTipsForPickup   = session.restaurantInformation.paymentOptions.showTipsOptionForPickup;
        this.showTipsForDelivery = session.restaurantInformation.paymentOptions.showTipsOptionForDelivery;
        
        
        if(!this.didWeCheckIfNoTipsYet && isDelivery && this.showTipsForDelivery && this.isUserSignedIn && this.isSessionValid) {
          if (this.selectedTipBtn == null) {
            console.log("NO TIPS SELECTED. WE ARE ADDING 15%!")
            this.tipPercentageBtnClicked(0, 15);
          }
          this.didWeCheckIfNoTipsYet = true;
      }





        //--- CUSTOMER INFORMATION ---\\
        this.customerId = session.customerInfo.id;
        this.customerName = session.customerInfo.name;
        this.customerPhone = session.customerInfo.phone;
        this.customerAddress = session.customerAddress.address;
        this.customerAddressNote = session.customerAddress.additionalNotes;





        //-- ORDER PREPARATION TIME INFO --\\
        if(session.restaurantInformation!=null){
          if(session.restaurantInformation.minTimeForPickup!=null && session.restaurantInformation.minTimeForPickup>0){
            this.pickupPreparationTime = session.restaurantInformation.minTimeForPickup + " min";
          }else{
            this.pickupPreparationTime = null;
          }

          if(session.restaurantInformation.minTimeForDelivery!=null && session.restaurantInformation.minTimeForDelivery>0){
            this.deliveryPreparationTime = session.restaurantInformation.minTimeForDelivery + " min";
          }else{
            this.deliveryPreparationTime = null;
          }
        }else{
          this.pickupPreparationTime = null;
          this.deliveryPreparationTime = null;
        }





        //--- Other Information ---\\
        if (session.isOneRestaurantMode) {
          this.isOneRestaurantMode = true;
          this.oneRestaurantModePickupOnly = (session.restaurantInformation.hasPickup && !session.restaurantInformation.hasDelivery);
          if(session.restaurantInformation!=null){
            this.selectedRestaurantId = session.restaurantInformation.restaurantId
          }
        } else {
          this.isOneRestaurantMode = false;
          this.oneRestaurantModePickupOnly = false;
        }

      })
      //===== Session initialization END =====\\







      this.orderDetailsChangedSubscription = this.avantoSession.orderDetailsChangedSubject.subscribe(() => {
        this.validateSession().catch((err) => { console.log(err) });
      })
    });
  }

  ngOnDestroy() {
    this.sessionSubscription.unsubscribe();
    this.orderDetailsChangedSubscription.unsubscribe();
  }

  //====================== METHODS ======================\\


  //--- CHECKOUT ---\\

  /** Checks if the session is valid and then checks your order out */
  validateAndCheckout(payType) {
    this.validateSession(true).then(() => {
      this.performCheckout(payType);
    })
  }

  validateAndSquareCheckout(isContactless) {
    this.validateSession(true).then(() => {
      this.avantoRoute.goToSquareCheckoutPage(isContactless);
    })
  }

  /**
   * How does this work?
   * You are redirected to the moneris payment page
   * You pay there
   * Then they call a lambda function on the "AVANTOEATS-PAYMENTS" project
   * Then, that function processes your payment and redirects you back to avantoeats (moneris-checkout component)
   */
  validateAndMonerisCheckout(){
    this.validateSession(true).then(() => {

      const mapForm = document.createElement('form');
      mapForm.method = 'POST';
      mapForm.action = 'https://www3.moneris.com/HPPDP/index.php';
      mapForm.style.display = 'none';
      
      Object.entries(this.monerisPostParams).forEach((param:any)=>{
        if(!param[0].includes("mobile")){
          //The parameters for the mobile app are different. If the key includes "mobile" in it, we ignore it.
          this.generateHiddenParam(param[0],param[1],mapForm)
        }
      })

      //For the ID, we use TIMESTAMP.ORDER_ID
      //the timestamp is there because if there is an error during the order, moneris wont accept another order with the same ID.
      this.generateHiddenParam('order_id', new Date().getTime() + "." + this.sessionId, mapForm);

      this.generateHiddenParam('charge_total', this.total, mapForm);
      this.generateHiddenParam('cust_id', this.customerId, mapForm);
      this.generateHiddenParam('bill_first_name',this.customerName, mapForm);
      this.generateHiddenParam('bill_phone',this.customerPhone, mapForm);
      
      document.body.appendChild(mapForm);
      mapForm.submit();
    })
  }


  validateAndThirdPartyCheckout(isContactless){
    if(this.thirdPartyPaymentType == "converge"){
      this.validateSession(true).then(() => {
          this.validateAndConvergeCheckout();
      })
    }else if(this.thirdPartyPaymentType == "square"){
      this.validateAndSquareCheckout(isContactless);
    }else{
      Swal.fire("Could not process payment","Please try another payment method","error");
      this.showProcessingSpinner = false;
    }
  }


  /**
   * How does this work?
   * You are redirected to our AvantoEats server on amazon EC2
   * This server has a PHP script that redirects you to Converge's hosted pay page
   * You pay there
   * Then they call a lambda function on the "AVANTOEATS-PAYMENTS" project
   * Then, that function processes your payment and redirects you back to avantoeats (moneris-checkout component)
   * 
   * ---
   * 
   * WHY REDIRECT TO OUR EC2 SERVER FIRST?
   * Because Converge is has some huge restrictions with security, they need to whitelist your IP for it to work
   *  and the place where avantoeats.com is hosted (cloundfront) doesnt have a fixed IP.
   * THAT MEANS THIS WONT WORK ON YOUR COMPUTER IF YOU TRY TO TEST IT LOCALLY, UNLES...
   *   If you need to whitelist your local IP for testing purposes, call: 1-800-377-3962
   *   Good luck.
   * If you want to see the code for our EC2 php function:
   *   > go to our ec2 server
   *   > var/www/html
   *   > index.php will redirect you to the "AvantoAPI/ConvergePayment" folder, provided you pass them the adequate post params (read their index.php, first few lines)
   */
  validateAndConvergeCheckout(){
      let payPageLink;
      let postParams;

      Object.entries(this.thirdPartyPaymentParams).forEach((param:any)=>{
        if(param[0]== "hostedPayPageLink"){
          payPageLink = param[1];
        } else if(param[0]== "hostedPayPagePostParams"){
          postParams = param[1];
        }
      })

        const mapForm = document.createElement('form');
        mapForm.method = 'POST';
        mapForm.action = payPageLink;
        mapForm.style.display = 'none';

        const sessionIdInput = document.createElement("input");
        sessionIdInput.setAttribute("type", "hidden");
        sessionIdInput.setAttribute("name", "sessionId");
        sessionIdInput.setAttribute("value", this.sessionId);
        mapForm.append(sessionIdInput);

        const orderAmountInput = document.createElement("input");
        orderAmountInput.setAttribute("type", "hidden");
        orderAmountInput.setAttribute("name", "orderAmount");
        orderAmountInput.setAttribute("value", this.total.toString());
        mapForm.append(orderAmountInput);
        
        postParams.forEach(param => {
          const paramObj = Object.entries(param)[0];
          const paramName = paramObj[0] as string;
          const paramValue = paramObj[1] as string;

          const postParamInput = document.createElement("input");
          postParamInput.setAttribute("type", "hidden");
          postParamInput.setAttribute("name", paramName);
          postParamInput.setAttribute("value", paramValue);
          mapForm.append(postParamInput);
        });

        document.body.appendChild(mapForm);
        mapForm.submit();
  }

  private generateHiddenParam(name,value, formToAppendTo){
    const param = document.createElement('input');
    param.type = 'hidden';
    param.name = name;
    param.value = value;
    formToAppendTo.appendChild(param);
  }

  /**
   * Checks if the session is valid, and if the customer can order from the selected restaurant
   * @param dontHideSpinnerAfterwards if true, hides the processing spinner after this function is done executing
   */
  validateSession(dontHideSpinnerAfterwards?:boolean) {
    if(!dontHideSpinnerAfterwards){
      this.validateSessionIsRunningAndWillStopSpinner = true;
    }
    return new Promise<void>((resolve, reject) => {
      this.showProcessingSpinner = true;
      this.isFutureOrderTimeValidTxt  = null;
      this.isRestaurantAvailableTxt   = null;
      this.isCartValidtxt             = null;
      this.invalidCartItemList        = [];
      this.isOrderTotalValidTxt       = null;
      this.highlightDateTimeSelectionArea = false;
      let hasError = false;
      
      this.avantoSession.validateSession().then(response => {
        if (response.error != null) {
          //Future order within one hour from now
          if (response.error.errorCode == 0) {
            this.isFutureOrderTimeValidTxt = response.error.errorResponse;
            this.highlightDateTimeSelectionArea = true;
            AvantoAlert.toast("error", "Invalid Order Time");
            hasError = true;
          }

          //Restaurant unavailable
          else if (response.error.errorCode == 1) {
            this.isRestaurantAvailableTxt = response.error.errorResponse;
            this.highlightDateTimeSelectionArea = true;
            AvantoAlert.toast("error", "Restaurant Unavailable");
            hasError = true;
          }

          //Invalid cart items
          else if (response.error.errorCode == 2) {
            let itemListString = "";
            (response.error.errorResponse as { itemTitle: string, itemId: string }[]).forEach(item => {
              this.invalidCartItemList.push(item.itemId);
              if (itemListString != "") {
                itemListString += "; ";
              }
              itemListString += item.itemTitle;
            })

            this.isCartValidtxt = "Invalid cart items: " + itemListString;

            hasError = true;

            Swal.fire({
              title: 'Your cart contains invalid items.',
              text: itemListString,
              type: 'warning',
              confirmButtonColor: '#f30',
              cancelButtonColor: '#212529',
              confirmButtonText: 'Remove invalid items from cart'
            }).then((result) => {
              if (result.value) {
                this.removeInvalidCartItems();
              }
            })
          }

          //Order total is too low
          else if (response.error.errorCode == 3) {
            //A session may be returned here, with the updated cart values
            if(response.session!=null){
              this.avantoSession.requestSessionUpdate(response.session,false,false);
            }
            this.isOrderTotalValidTxt = response.error.errorResponse;
            AvantoAlert.toast("error",response.error.errorResponse)
            hasError = true;
          } 

          //Order already exists
          else if (response.error.errorCode == 4) {
            this.isRestaurantAvailableTxt = response.error.errorResponse;
            this.highlightDateTimeSelectionArea = true;
            AvantoAlert.toast("error", response.error.errorResponse);
            hasError = true;
          } 

          //YOU SHOULDNT GET THIS... BUT....
          else {
            Swal.fire('Could not validate your cart', '','error')
            hasError = true;
          }


          if(hasError){
            reject();
            this.isSessionValid = false;
          }
        } 
        //ORDER IS VALID!!!
        else {
          if(response.session!=null){
            this.avantoSession.requestSessionUpdate(response.session,false,false);
          }
          this.isSessionValid = true;
          resolve();
        }
      })
      .catch((err)=>{
        reject();
      })
      .finally(() => {
        this.wasSessionValidatedAtLeastOnce = true;
        this.validateSessionIsRunningAndWillStopSpinner = false;
        if(!dontHideSpinnerAfterwards){
          this.showProcessingSpinner = false;
        }
      });
    });
  }

  removeInvalidCartItems(){
    this.showProcessingSpinner = true;
    this.avantoSession.removeItemFromSession(this.invalidCartItemList)
    .then(() => {
      this.validateSession();
    })
    .catch(() => {
      AvantoAlert.toast("error", "could not remove items from cart")
    })
  }

  /** User selected "pay online". He is redirected to the pay online page */
  goToPayOnlinePage() {
    console.log("REMOVE THIS?");
    // this.validateSession().then(() => {
    //   this.avantoRoute.goToPayOnlinePage();
    // }).catch(()=>{
    //   console.log('could not validate the session.')
    // })
  }


  editCartBtnClicked() {
    if (this.cartSelectedRestaurant == null || this.cartSelectedRestaurant == "") {
      //This should NEVER happen... but I will put it here just in case
      Swal.fire("Could not go to the restaurant page", "Please, try refreshing the page", "error")
    } else {
      const restaurantSplit = this.cartSelectedRestaurant.split(".");
      if (this.isOneRestaurantMode) {
        this.avantoRoute.goToOneRestaurantModeChooseFoodPage(restaurantSplit[0], restaurantSplit[1])
      } else {
        this.avantoRoute.goToChooseFoodPage(restaurantSplit[0], restaurantSplit[1])
      }
    }
  }

  changeOrderDetails() {
    if (this.oneRestaurantModePickupOnly) {
      this.avantoModal.openOrderDetailsModal(false, true, false);
    } else {
      this.avantoModal.openOrderDetailsModal(true, true, true);
    }
  }

  
  signInBtnClicked() {
    this.avantoRoute.goToCustomerLoginPageThenReturnToCheckout()
  }

  createAccountBtnClicked() {
    this.avantoRoute.goToCustomerSignUpPageThenReturnToCheckout()
  }


  scrollToTop() {
    ScrollFunctions.scrollToTop()
  }

  ngAfterViewInit() {
    this.avantoModal.closeCartModal();
  }

  goToSelectRestaurants(){
    if(this.isOneRestaurantMode==false || this.selectedRestaurantId == null || this.selectedRestaurantId == '' ){
      this.avantoRoute.goToChooseRestaurantPage();
    }else{
      const restaurantIdSplit = this.selectedRestaurantId.split(".")
      this.avantoRoute.goToOneRestaurantModeChooseFoodPage(restaurantIdSplit[0],restaurantIdSplit[1])
    }
  }

  tipPercentageBtnClicked(btnNumber: number, percentage) {
    const tipValue = this.calculateTipPercentageValue(percentage);
    this.addTipValue(tipValue, btnNumber)
  }

  async customTipBtnClicked(btnNumber: number) {

    Swal.fire({
      title: 'Insert the tip percentage you want to give',
      input: 'number',
      inputAttributes: {
        min: '1'
      },
      showCancelButton: true,
      confirmButtonText: 'Add Tip',
    }).then((result) => {
      if (result.value) {
        const tipValue = this.calculateTipPercentageValue(result.value);
        this.addTipValue(tipValue, btnNumber)
      }
    })

    
    // let alert = await this.alertCtrl.create({
    //   header: 'Custom tip',
    //   message: "",
    //   inputs: [{ name: 'tip', type: 'number', min: 1 }],
    //   buttons: [
    //     {
    //       text: 'Close',
    //       role: 'cancel'
    //     },
    //     {
    //       text: 'Remove Tip',
    //       handler: _data => {
    //         this.removeTip();
    //       }
    //     },
    //     {
    //       text: 'Add tip',
    //       handler: data => {
    //         const tipValue = this.calculateTipPercentageValue(data['tip']);
    //         this.addTipValue(tipValue, btnNumber)
    //       }
    //     }
    //   ]
    // });

    // await alert.present();
  }

  async applyCouponBtnClicked() {
    Swal.fire({
      title: 'Insert the coupon code',
      input: 'text',
      inputAttributes: {
        min: '1'
      },
      showCancelButton: true,
      
      confirmButtonText: 'Apply',
    }).then((result) => {
      if (result.value) {
        this.showProcessingSpinner = true;
        this.avantoSession.applyCoupon(result.value)
          .then(() => {
            AvantoAlert.toast("success","Coupon added");
            this.validateSession();
          })
          .catch((err) => {
            const error = err.json().error;
            console.error(error)
            Swal.fire("Could not apply the coupon", error, "error")
            //We dont do this on the "then" condition, because the "validateSession" message will hide the spinner for us
            this.showProcessingSpinner = false;
          });
      }
    })


    // let alert = await this.alertCtrl.create({
    //   header: 'Insert the coupon code',
    //   inputs: [{ name: 'coupon' }],
    //   buttons: [
    //     {
    //       text: 'Close',
    //       role: 'cancel'
    //     },
    //     {
    //       text: 'Apply',
    //       handler: data => {
            
    //       }
    //     }
    //   ]
    // });

    // await alert.present();
  }

  removeCouponClicked() {
    this.showProcessingSpinner = true;
    this.avantoSession.removeCoupon()
      .then(() => {
        AvantoAlert.toast("success","Coupon removed");
        this.validateSession();
      })
      .catch((err) => {
        console.log(err)
        AvantoAlert.toast("error","Could not remove coupon");
        //We dont do this on the "then" condition, because the "validateSession" message will hide the spinner for us
        this.showProcessingSpinner = false;
      });
  }

  private calculateTipPercentageValue(percentage) {
    const percentageVal = new BigNumber(percentage).div(new BigNumber(100));
    return new BigNumber(this.subtotal).times(percentageVal).decimalPlaces(2).toNumber();
  }

  private addTipValue(tipValue, highlightBtnId) {
    this.showProcessingSpinner = true;

    if (tipValue <= 0) {
      AvantoAlert.toast("error","Invalid tip value.");
      this.showProcessingSpinner = false;
    } else {
      this.avantoSession.setTip(tipValue)
        .then(() => {
          AvantoAlert.toast("success","Tip added: $" + tipValue.toFixed(2));
          this.selectedTipBtn = highlightBtnId;
          this.selectedTipValue = tipValue;
          this.validateSession();
        })
        .catch(() => {
          AvantoAlert.toast("error","Could not add tip. Try again.");
          //We dont do this on the "then" condition, because the "validateSession" message will hide the spinner for us
          this.showProcessingSpinner = false;
        });
    }
  }

  removeTip() {
    this.showProcessingSpinner = true;
    this.avantoSession.setTip(0)
      .then(() => {
        AvantoAlert.toast("success","Tip removed");
        this.selectedTipBtn = null;
        this.selectedTipValue = null;
        this.validateSession();
      })
      .catch(() => {
        AvantoAlert.toast("error","Could not remove tip. Try again.");
        //We dont do this on the "then" condition, because the "validateSession" message will hide the spinner for us
        this.showProcessingSpinner = false;
      });
  }

  //================================= CHECKOUT =================================\\
  
  /**
   * Saves your order on the database.
   * @param payMethod payment method used to make the order
   */
  performCheckout(payMethod: string, last4DigitsCreditCard?:string) {
    this.showProcessingSpinner = true;
    this.avantoSession.checkout(payMethod, last4DigitsCreditCard).then((response: any) => {
      //TODO: I should make a function for the checkout... IF YOU CHANGE HERE, ALSO CHANGE THE PAYMENT-PAGE.COMPONNT
      let orderCompleteParam = null;
      this.customerService.updateForNewOrder(response.checkoutDetailsForUserUpdate)
        .then((response)=>{
          if(response!=null && response.showCampaignToCustomerAtCheckout!=null){
            orderCompleteParam = 'success-'+response.showCampaignToCustomerAtCheckout;
          }
        })
        .finally(() => {
          this.avantoSession.clearSession()
            .catch(() => {
              this.avantoSession.removeSessionFromCookie();
            })
            .finally(() => {
              this.avantoRoute.goToOrderCompletePage(orderCompleteParam)
            })
        })
    }).catch(err => {
      console.log(err)
      this.showProcessingSpinner = false;
      //TODO: RETURN MONEY!
      Swal.fire("Error", "Could not complete the checkout", "error")
    });
  }
  
  //=============================== CHECKOUT  END ===============================\\

}
